import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { BarcodedUnit } from './BarcodedUnit'
import { Order } from './Order'

export class OrderBarcodedUnit extends Base {
  @Expose({ name: 'unit' })
  @Transform(({ unit }) => unit?.guid)
  guid: string = ''

  @Type(() => Order)
  order?: Order

  @Type(() => BarcodedUnit)
  unit?: BarcodedUnit
}
